import React, { useEffect, useRef, useState } from 'react';

interface Props {
  currentScore: number;
  isStreamInterface?: boolean;
}

const AnimatedScore: React.FC<Props> = ({ currentScore, isStreamInterface = false }) => {
  const previousScoreRef = useRef(currentScore);
  const [displayScore, setDisplayScore] = useState(currentScore);
  const [scoreDiff, setScoreDiff] = useState<number | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const diff = currentScore - previousScoreRef.current;

    if (diff > 0) {
      // Mostrar +N con el estilo visual nuevo
      setScoreDiff(diff);

      // Luego iniciar el conteo progresivo como antes
      const timeout = setTimeout(() => {
        setScoreDiff(null);

        const startValue = previousScoreRef.current;
        const endValue = currentScore;
        let current = startValue;

        intervalRef.current = setInterval(() => {
          current += 1;
          setDisplayScore(current);

          if (current >= endValue) {
            if (intervalRef.current) clearInterval(intervalRef.current);
            previousScoreRef.current = currentScore;
          }
        }, 20);
      }, 2000);

      return () => clearTimeout(timeout);
    } else {
      setDisplayScore(currentScore);
      previousScoreRef.current = currentScore;
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [currentScore]);

  const pointsGainClasses = `points-gained-animation ${isStreamInterface ? 'stream-style' : ''}`;

  return (
    <div className="relative">
      <p className="font-gaming text-gaming-gold text-xl leading-none">{displayScore}</p>
      {scoreDiff !== null && (
        <div className={pointsGainClasses}>
          +{scoreDiff}
        </div>
      )}
    </div>
  );
};

export default AnimatedScore;
